import { render, staticRenderFns } from "./RenameFlowModal.vue?vue&type=template&id=0bf6df31"
import script from "./RenameFlowModal.vue?vue&type=script&lang=js"
export * from "./RenameFlowModal.vue?vue&type=script&lang=js"
import style0 from "./RenameFlowModal.vue?vue&type=style&index=0&id=0bf6df31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports